module.exports = __webpack_public_path__ + "f43654df7ba69df60fddd4f5de90210f.png";